import styled from 'styled-components';

export const ImageWrapper = styled.div`
  margin-top: calc(var(--gap) * -1);
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;

export const Name = styled.p`
  margin: 0;
  font-family: Butler, serif;
  font-weight: 700;
  font-size: 24px;
  text-transform: initial;
`;

export const Description = styled.p`
  margin: 0;
  white-space: pre-wrap;
`;
